export const currencySymbolByCode = (currency: string) => currencies.find(c => c.code === currency.toUpperCase())?.symbol

export const currencies = [
    { "code": "EUR", "name": "Euro", "default": true, "symbol": "€" },
    { "code": "USD", "name": "United States dollar", "symbol": "$" },
    { "code": "AED", "name": "United Arab Emirates dirham", "symbol": "د.إ" },
    { "code": "AFN", "name": "Afghan afghani", "symbol": "؋" },
    { "code": "ALL", "name": "Albanian lek", "symbol": "Lek" },
    { "code": "AMD", "name": "Armenian dram", "symbol": "AMD" },
    { "code": "AOA", "name": "Angolan kwanza", "symbol": "Kz" },
    { "code": "ARS", "name": "Argentine peso", "symbol": "$" },
    { "code": "AUD", "name": "Australian dollar", "symbol": "$" },
    { "code": "AWG", "name": "Aruban florin", "symbol": "ƒ" },
    { "code": "AZN", "name": "Azerbaijani manat", "symbol": "₼" },
    { "code": "BAM", "name": "Bosnia and Herzegovina convertible mark", "symbol": "KM" },
    { "code": "BBD", "name": "Barbadian dollar", "symbol": "$" },
    { "code": "BDT", "name": "Bangladeshi taka", "symbol": "৳" },
    { "code": "BGN", "name": "Bulgarian lev", "symbol": "лв" },
    { "code": "BHD", "name": "Bahraini dinar", "symbol": ".د.ب" },
    { "code": "BIF", "name": "Burundian franc", "symbol": "FBu" },
    { "code": "BMD", "name": "Bermudian dollar", "symbol": "$" },
    { "code": "BND", "name": "Brunei dollar", "symbol": "$" },
    { "code": "BOB", "name": "Bolivian boliviano", "symbol": "$b" },
    { "code": "BRL", "name": "Brazilian real", "symbol": "R$" },
    { "code": "BSD", "name": "Bahamian dollar", "symbol": "$" },
    { "code": "BTN", "name": "Bhutanese ngultrum", "symbol": "Nu." },
    { "code": "BWP", "name": "Botswana pula", "symbol": "P" },
    { "code": "BYR", "name": "Belarusian ruble", "symbol": "p." },
    { "code": "BZD", "name": "Belize dollar", "symbol": "BZ$" },
    { "code": "CAD", "name": "Canadian dollar", "symbol": "$" },
    { "code": "CDF", "name": "Congolese franc", "symbol": "FC" },
    { "code": "CHF", "name": "Swiss franc", "symbol": "CHF" },
    { "code": "CLP", "name": "Chilean peso", "symbol": "$" },
    { "code": "CNY", "name": "Chinese yuan", "symbol": "¥" },
    { "code": "COP", "name": "Colombian peso", "symbol": "$" },
    { "code": "CRC", "name": "Costa Rican colon", "symbol": "₡" },
    { "code": "CUC", "name": "Cuban convertible peso", "symbol": "$" },
    { "code": "CUP", "name": "Cuban peso", "symbol": "$" },
    { "code": "CVE", "name": "Cape Verdean escudo", "symbol": "$" },
    { "code": "CZK", "name": "Czech koruna", "symbol": "Kč" },
    { "code": "DJF", "name": "Djiboutian franc", "symbol": "Fdj" },
    { "code": "DKK", "name": "Danish krone", "symbol": "kr" },
    { "code": "DOP", "name": "Dominican peso", "symbol": "RD$" },
    { "code": "DZD", "name": "Algerian dinar", "symbol": "دج" },
    { "code": "EGP", "name": "Egyptian pound", "symbol": "£" },
    { "code": "ERN", "name": "Eritrean nakfa", "symbol": "Nfk" },
    { "code": "ETB", "name": "Ethiopian birr", "symbol": "Br" },
    { "code": "FJD", "name": "Fijian dollar", "symbol": "$" },
    { "code": "FKP", "name": "Falkland Islands pound", "symbol": "£" },
    { "code": "GBP", "name": "British pound", "symbol": "£" },
    { "code": "GEL", "name": "Georgian lari", "symbol": "₾" },
    { "code": "GGP", "name": "Guernsey pound", "symbol": "£" },
    { "code": "GHS", "name": "Ghanaian cedi", "symbol": "₵" },
    { "code": "GIP", "name": "Gibraltar pound", "symbol": "£" },
    { "code": "GMD", "name": "Gambian dalasi", "symbol": "D" },
    { "code": "GNF", "name": "Guinean franc", "symbol": "FG" },
    { "code": "GTQ", "name": "Guatemalan quetzal", "symbol": "Q" },
    { "code": "GYD", "name": "Guyanese dollar", "symbol": "$" },
    { "code": "HKD", "name": "Hong Kong dollar", "symbol": "HK$" },
    { "code": "HNL", "name": "Honduran lempira", "symbol": "L" },
    { "code": "HRK", "name": "Croatian kuna", "symbol": "kn" },
    { "code": "HTG", "name": "Haitian gourde", "symbol": "G" },
    { "code": "HUF", "name": "Hungarian forint", "symbol": "Ft" },
    { "code": "IDR", "name": "Indonesian rupiah", "symbol": "Rp" },
    { "code": "ILS", "name": "Israeli new shekel", "symbol": "₪" },
    { "code": "IMP", "name": "Manx pound", "symbol": "£" },
    { "code": "INR", "name": "Indian rupee", "symbol": "₹" },
    { "code": "IQD", "name": "Iraqi dinar", "symbol": "ع.د" },
    { "code": "IRR", "name": "Iranian rial", "symbol": "﷼" },
    { "code": "ISK", "name": "Icelandic króna", "symbol": "kr" },
    { "code": "JEP", "name": "Jersey pound", "symbol": "£" },
    { "code": "JMD", "name": "Jamaican dollar", "symbol": "J$" },
    { "code": "JOD", "name": "Jordanian dinar", "symbol": "JD" },
    { "code": "JPY", "name": "Japanese yen", "symbol": "¥" },
    { "code": "KES", "name": "Kenyan shilling", "symbol": "KSh" },
    { "code": "KGS", "name": "Kyrgyzstani som", "symbol": "лв" },
    { "code": "KHR", "name": "Cambodian riel", "symbol": "៛" },
    { "code": "KMF", "name": "Comorian franc", "symbol": "CF" },
    { "code": "KPW", "name": "North Korean won", "symbol": "₩" },
    { "code": "KRW", "name": "South Korean won", "symbol": "₩" },
    { "code": "KWD", "name": "Kuwaiti dinar", "symbol": "د.ك" },
    { "code": "KYD", "name": "Cayman Islands dollar", "symbol": "$" },
    { "code": "KZT", "name": "Kazakhstani tenge", "symbol": "₸" },
    { "code": "LAK", "name": "Lao kip", "symbol": "₭" },
    { "code": "LBP", "name": "Lebanese pound", "symbol": "£" },
    { "code": "LKR", "name": "Sri Lankan rupee", "symbol": "Rs" },
    { "code": "LRD", "name": "Liberian dollar", "symbol": "$" },
    { "code": "LSL", "name": "Lesotho loti", "symbol": "L" },
    { "code": "LTL", "name": "Lithuanian litas", "symbol": "Lt" },
    { "code": "LVL", "name": "Latvian lats", "symbol": "Ls" },
    { "code": "LYD", "name": "Libyan dinar", "symbol": "ل.د" },
    { "code": "MAD", "name": "Moroccan dirham", "symbol": "د.م." },
    { "code": "MDL", "name": "Moldovan leu", "symbol": "lei" },
    { "code": "MGA", "name": "Malagasy ariary", "symbol": "Ar" },
    { "code": "MKD", "name": "Macedonian denar", "symbol": "ден" },
    { "code": "MMK", "name": "Myanmar kyat", "symbol": "K" },
    { "code": "MNT", "name": "Mongolian tögrög", "symbol": "₮" },
    { "code": "MOP", "name": "Macanese pataca", "symbol": "MOP$" },
    { "code": "MRO", "name": "Mauritanian ouguiya", "symbol": "UM" },
    { "code": "MUR", "name": "Mauritian rupee", "symbol": "₨" },
    { "code": "MVR", "name": "Maldivian rufiyaa", "symbol": "Rf" },
    { "code": "MWK", "name": "Malawian kwacha", "symbol": "MK" },
    { "code": "MXN", "name": "Mexican peso", "symbol": "$" },
    { "code": "MYR", "name": "Malaysian ringgit", "symbol": "RM" },
    { "code": "MZN", "name": "Mozambican metical", "symbol": "MT" },
    { "code": "NAD", "name": "Namibian dollar", "symbol": "$" },
    { "code": "NGN", "name": "Nigerian naira", "symbol": "₦" },
    { "code": "NIO", "name": "Nicaraguan córdoba", "symbol": "C$" },
    { "code": "NOK", "name": "Norwegian krone", "symbol": "kr" },
    { "code": "NPR", "name": "Nepalese rupee", "symbol": "₨" },
    { "code": "NZD", "name": "New Zealand dollar", "symbol": "$" },
    { "code": "OMR", "name": "Omani rial", "symbol": "﷼" },
    { "code": "PAB", "name": "Panamanian balboa", "symbol": "B/." },
    { "code": "PEN", "name": "Peruvian sol", "symbol": "S/." },
    { "code": "PGK", "name": "Papua New Guinean kina", "symbol": "K" },
    { "code": "PHP", "name": "Philippine peso", "symbol": "₱" },
    { "code": "PKR", "name": "Pakistani rupee", "symbol": "₨" },
    { "code": "PLN", "name": "Polish złoty", "symbol": "zł" },
    { "code": "PYG", "name": "Paraguayan guaraní", "symbol": "₲" },
    { "code": "QAR", "name": "Qatari riyal", "symbol": "﷼" },
    { "code": "RON", "name": "Romanian leu", "symbol": "lei" },
    { "code": "RSD", "name": "Serbian dinar", "symbol": "дин." },
    { "code": "RUB", "name": "Russian ruble", "symbol": "₽" },
    { "code": "RWF", "name": "Rwandan franc", "symbol": "FRw" },
    { "code": "SAR", "name": "Saudi riyal", "symbol": "﷼" },
    { "code": "SBD", "name": "Solomon Islands dollar", "symbol": "$" },
    { "code": "SCR", "name": "Seychellois rupee", "symbol": "₨" },
    { "code": "SDG", "name": "Sudanese pound", "symbol": "£" },
    { "code": "SEK", "name": "Swedish krona", "symbol": "kr" },
    { "code": "SGD", "name": "Singapore dollar", "symbol": "$" },
    { "code": "SHP", "name": "Saint Helena pound", "symbol": "£" },
    { "code": "SLL", "name": "Sierra Leonean leone", "symbol": "Le" },
    { "code": "SOS", "name": "Somali shilling", "symbol": "Sh" },
    { "code": "SRD", "name": "Surinamese dollar", "symbol": "$" },
    { "code": "STD", "name": "São Tomé and Príncipe dobra", "symbol": "Db" },
    { "code": "SVC", "name": "Salvadoran colón", "symbol": "₡" },
    { "code": "SYP", "name": "Syrian pound", "symbol": "£" },
    { "code": "SZL", "name": "Swazi lilangeni", "symbol": "L" },
    { "code": "THB", "name": "Thai baht", "symbol": "฿" },
    { "code": "TJS", "name": "Tajikistani somoni", "symbol": "ЅМ" },
    { "code": "TMT", "name": "Turkmenistan manat", "symbol": "m" },
    { "code": "TND", "name": "Tunisian dinar", "symbol": "د.ت" },
    { "code": "TOP", "name": "Tongan paʻanga", "symbol": "T$" },
    { "code": "TRY", "name": "Turkish lira", "symbol": "₺" },
    { "code": "TTD", "name": "Trinidad and Tobago dollar", "symbol": "TT$" },
    { "code": "TWD", "name": "New Taiwan dollar", "symbol": "NT$" },
    { "code": "TZS", "name": "Tanzanian shilling", "symbol": "TSh" },
    { "code": "UAH", "name": "Ukrainian hryvnia", "symbol": "₴" },
    { "code": "UGX", "name": "Ugandan shilling", "symbol": "USh" },
    { "code": "USD", "name": "United States dollar", "symbol": "$" },
    { "code": "UYU", "name": "Uruguayan peso", "symbol": "$U" },
    { "code": "UZS", "name": "Uzbekistani som", "symbol": "лв" },
    { "code": "VEF", "name": "Venezuelan bolívar", "symbol": "Bs" },
    { "code": "VND", "name": "Vietnamese đồng", "symbol": "₫" },
    { "code": "VUV", "name": "Vanuatu vatu", "symbol": "Vt" },
    { "code": "WST", "name": "Samoan tālā", "symbol": "WS$" },
    { "code": "XAF", "name": "Central African CFA franc", "symbol": "FCFA" },
    { "code": "XAG", "name": "Silver (troy ounce)", "symbol": "oz t" },
    { "code": "XAU", "name": "Gold (troy ounce)", "symbol": "oz t" },
    { "code": "XCD", "name": "East Caribbean dollar", "symbol": "$" },
    { "code": "XDR", "name": "Special drawing rights", "symbol": "SDR" },
    { "code": "XOF", "name": "West African CFA franc", "symbol": "CFA" },
    { "code": "XPF", "name": "CFP franc", "symbol": "₣" },
    { "code": "YER", "name": "Yemeni rial", "symbol": "﷼" },
    { "code": "ZAR", "name": "South African rand", "symbol": "R" },
    { "code": "ZMK", "name": "Zambian kwacha (pre-2013)", "symbol": "ZK" },
    { "code": "ZMW", "name": "Zambian kwacha", "symbol": "ZK" },
    { "code": "ZWL", "name": "Zimbabwean dollar", "symbol": "Z$" }
]
